//
// Copyright 2023 DXOS.org
//

/**
 * Timeout for retrying messages.
 */
export const MESSAGE_TIMEOUT = 10_000;
